module.exports = __webpack_public_path__ + "static/media/large-csv.4cec7c27.svg";